import CfoSfoMappingsPage from "./cfoSfoMappingsPage";
export default CfoSfoMappingsPage;
